// What a flow's email-consent mode does to the candidate, in the recruiter's
// terms — the line an attestation screen shows before the recruiter attests.
//
// Two flows ask a recruiter to attest on the candidate's behalf, and each is
// per job: Apply from Suitable Jobs and resume re-upload. Both screens read
// their line from here so the two never drift apart.
//
// The org-settings switch states the same fact in its own words. That copy
// lives once, server-side, in `EMAIL_CONSENT_FLOWS` (app/config/email_consent.py),
// and is not duplicated here.
//
// Tri-state on purpose, like the career portal's apply screen: a read that
// carried no answer gets no line at all rather than a promise that may be
// wrong.
const note = (required, emailed, instant) => {
  if (typeof required !== "boolean") return null;
  return required ? emailed : instant;
};

export const jobfitApplyConsentNote = (required) =>
  note(
    required,
    "The candidate will be emailed a confirmation link — the application is complete once they click it.",
    "The application is submitted as soon as you continue — the candidate is never asked to confirm it.",
  );

export const reuploadConsentNote = (required) =>
  note(
    required,
    "The candidate will be emailed a confirmation link — the resume on file is replaced once they click it.",
    "The resume on file is replaced as soon as you submit — the candidate is never asked to confirm it, and never sees the replacement.",
  );
